import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserRoleAuthGuard } from './core/guards/user-role-auth.guard';
import { NotfoundPageComponent } from './features/pages/notfound-page/notfound-page.component';
import { AcceptInvitationModule } from './features/components/accept-invitation/accept-invitation.module';

const routes: Routes = [
  { path: '404', component: NotfoundPageComponent },
   {
    path: 'accept-invitation',
    loadChildren: () => import('./features/components/accept-invitation/accept-invitation.module')
      .then(m => m.AcceptInvitationModule)
  },
  {
    path: 'core',
    loadChildren: () => import('./core/core.module').then(m => m.CoreModule),
    canActivate: [UserRoleAuthGuard]
  },
  {
    path: 'shared',
    loadChildren: () => import('./shared/shared.module').then(m => m.SharedModule)
  },
  {
    path: '',
    loadChildren: () => import('./features/features.module').then(m => m.FeaturesModule)
  },
  { path: '**', redirectTo: '/404' }
]

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking'
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
